import { render, staticRenderFns } from "./Acceptance.vue?vue&type=template&id=cb66f7d8&"
import script from "./Acceptance.vue?vue&type=script&lang=ts&"
export * from "./Acceptance.vue?vue&type=script&lang=ts&"
import style0 from "./Acceptance.vue?vue&type=style&index=0&id=cb66f7d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports